import PageLayout from "@/components/PageLayout";
import ArticleSchema from "@/components/ArticleSchema";

const ZeefdrukOfTransferdruk = () => (
 <PageLayout
 title="Zeefdruk of transferdruk"
 metaDescription="Verschil tussen zeefdruk en transferdruk. Ontdek welke druktechniek het beste past bij uw project. Magic Print Den Haag adviseert u graag."
 >
 <ArticleSchema title="Zeefdruk of transferdruk?" description="Verschil tussen zeefdruk en transferdruk." slug="/zeefdruk-of-transferdruk" />
 <h1 className="text-3xl md:text-5xl font-bold mb-6">
 Zeefdruk of transferdruk?
 </h1>
 <p className="text-lg text-muted-foreground mb-8">
 Bij Magic Print kunt u kiezen uit verschillende druktechnieken. Zeefdruk en transferdruk zijn twee van de meest populaire methoden. Maar welke techniek past het beste bij uw project? Wij leggen de verschillen uit.
 </p>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Zeefdruk</h2>
 <p className="text-muted-foreground mb-4">
 Zeefdruk is een klassieke druktechniek die ideaal is voor grote oplages. De inkt wordt door een fijn gaas (zeef) op het textiel gedrukt, wat zorgt voor heldere kleuren en een duurzaam resultaat. Bij grotere aantallen is zeefdruk vaak de meest voordelige optie.
 </p>
 <ul className="space-y-1 text-muted-foreground">
 <li> Voordelig bij grote oplages (vanaf 10 stuks)</li>
 <li> Zeer duurzaam en wasbestendig</li>
 <li> Heldere, dekkende kleuren</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Transferdruk</h2>
 <p className="text-muted-foreground mb-4">
 Bij transferdruk wordt het ontwerp eerst op een speciale folie of papier gedrukt en vervolgens met hitte en druk op het textiel overgebracht. Deze techniek is geschikt voor kleinere oplages en ontwerpen met veel details of kleuren.
 </p>
 <ul className="space-y-1 text-muted-foreground">
 <li> Geschikt voor kleine oplages</li>
 <li> Full-color prints mogelijk</li>
 <li> Gedetailleerde ontwerpen</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Welke techniek past bij u?</h2>
 <p className="text-muted-foreground">
 De beste keuze hangt af van uw specifieke wensen: het aantal stuks, het ontwerp, het type kleding en uw budget. Bij Magic Print adviseren wij u graag over de beste druktechniek voor uw project. Neem contact met ons op voor persoonlijk advies.
 </p>
 </section>
 </PageLayout>
);

export default ZeefdrukOfTransferdruk;
